import axios from 'axios';

const rawBase = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001').replace(/\/+$/, '');
const baseURL = rawBase.endsWith('/api') ? rawBase : `${rawBase}/api`;

export const API_BASE_URL = baseURL;

const API = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    // 'Content-Type' silindi: JSON göndərəndə avtomatik JSON,
    // FormData göndərəndə multipart/form-data seçiləcək
  },
  timeout: 60000,
});

API.interceptors.request.use((config) => {
  const token = typeof window !== 'undefined' ? window.localStorage.getItem('adminToken') : null;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config;
});

// ---------------------------------------------------------------
// COLD START ÜÇÜN TƏKRAR CƏHD
// Render pulsuz planda 15 dəq sonra yatır. İlk sorğu 502/503 ala
// və ya şəbəkə xətası ilə düşə bilər. Bu halda 3 dəfə təkrar edirik.
// GET sorğuları təhlükəsiz təkrarlanır; POST/PUT/DELETE TƏKRARLANMIR
// (yoxsa sifariş iki dəfə düşərdi).
// ---------------------------------------------------------------
const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 4000;

const isColdStart = (error) => {
  if (error.code === 'ECONNABORTED') return true;          // timeout
  if (!error.response) return true;                        // şəbəkə xətası
  return [502, 503, 504].includes(error.response.status);  // proxy oyanır
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

API.interceptors.response.use(
  (res) => res,
  async (error) => {
    const config = error.config;

    const method = (config?.method || 'get').toLowerCase();
    const retryable = method === 'get' || method === 'head';

    if (config && retryable && isColdStart(error)) {
      config.__retryCount = config.__retryCount || 0;

      if (config.__retryCount < MAX_RETRIES) {
        config.__retryCount += 1;
        console.warn(`[API] Server oyanır, təkrar cəhd ${config.__retryCount}/${MAX_RETRIES}...`);
        await sleep(RETRY_DELAY_MS);
        return API(config);
      }
    }

    if (error?.response) {
      console.error('[API error]', error.response.status, error.response.data);
    } else {
      console.error('[API error]', error.message);
    }
    return Promise.reject(error);
  }
);

export default API;
